import {put} from 'redux-saga/effects';
import moment from 'moment';
import config from '../../config';
import * as qualityManagementFeedbackActionTypes from '../qualityManagementFeedbackActionTypes';
import modalIds from '../../modalIds';

const loadQualityManagementFeedbackSearchResults = function* loadQualityManagementFeedbackSearchResults({payload}) {
    const {location} = payload;
    const searchQueryParams = new URLSearchParams(location.search);
    searchQueryParams.append('size', `${config.DEFAULT_PAGE_SIZE}`);
    if (!searchQueryParams.get('sort')) searchQueryParams.append('sort', 'createdAt,desc');
    if (!searchQueryParams.get('createdAfter')) {
        searchQueryParams.append('createdAfter', moment().subtract(config.DEFAULT_TIME_PERIOD_IN_MONTHS, 'months').toISOString());
    }
    if (!searchQueryParams.get('createdBefore')) searchQueryParams.append('createdBefore', moment().toISOString());
    searchQueryParams.append('countries', [config.CONTRACT_PARTNERS_SEARCH_COUNTRY_CODE].join(', '));

    // do not reload qm feedback search results when the agent opens a modal
    if (location && location.state?.isModalOpen
        && [modalIds.CP_CREATE_QUALITY_REPORT].includes(location.state?.modalId)
    ) return;


    yield put({
        type: qualityManagementFeedbackActionTypes.SEARCH_QUALITY_MANAGEMENT_FEEDBACKS,
        payload: {searchQueryParams},
    });
};

export default loadQualityManagementFeedbackSearchResults;
